<div class="page-container flex-row-flex-start-top">
    <div class="step-1-content flex-column-flex-start">
        <app-text size="xl" weight="xl" color="gray-900">
            早安！
        </app-text>

        @if(this.checkInStep === 2){
            <app-text size="xl" weight="xl" color="gray-900">
            您的健檢前問卷
            </app-text>
            <div class="idNo-area flex-column-flex-start">
                 <!-- 同意書/問卷 -->
                <div class="agreenment-card">
                    <div class="agreenment-card-content">
                    <app-text size="m" weight="m" color="gray-900">提前完成問卷，報到更順暢</app-text>
                    
                    <div class="flex-row-flex-start">
                        @if (completedCount() === sortedQuestionnaireStatusList.length && sortedQuestionnaireStatusList.length > 0) {
                        <!-- 若全部完成 -->
                        <img src="/assets/img/member-complete-state.svg" alt="alert">
                        <app-text size="s" weight="s" color="gray-900">已完成</app-text>
                        } @else {
                        <!-- 進度條 -->
                        <app-text size="s" weight="s" color="gray-900">{{completedCount()}}/{{sortedQuestionnaireStatusList.length}}</app-text>
                        <div class="progress-bar">
                            <mat-progress-bar mode="determinate" [value]="percentValue()"></mat-progress-bar>
                        </div>
                        
                        }
                    </div>
                    </div>
                    <hr>
                    @for (item of sortedQuestionnaireStatusList; track item.questionnaireTypeId) {
                    <div class="agreenment-card-content">
                    <div class="flex-row-flex-start">
                        <!-- 打勾與不勾 -->
                        @if (item.status === '1'){
                        <img src="/assets/img/member-undone-radio.svg" alt="undone">
                        }
                        <!-- 健調表未完成可修改 -->
                        @else if (item.questionnaireTypeId === '3'&& item.status === '4'){
                        <img src="/assets/img/member-undone-radio.svg" alt="undone">
                        }
                        @else{
                        <img src="/assets/img/member-complete-radio.svg" alt="complete">
                        }

                        <!-- 標題 -->
                        <app-text size="m" weight="s" color="gray-900">{{ item.questionnaireName }}</app-text>
                        
                        <!-- 狀態標籤(僅健調表在用) -->
                        @if (item.questionnaireTypeId === '3' && this.diffDays > 10) {
                        <app-tag size="sm" color="outline-blue">
                        <app-text size="s" weight="m" color="blue-600">健檢日前十天開放</app-text>
                        </app-tag>
                        }
                        @if (item.questionnaireTypeId === '3' && this.diffDays <= 10 && item.status === '4') {
                        <app-tag size="sm" color="outline-red">
                        <app-text size="s" weight="m" color="red-600">未完成</app-text>
                        </app-tag>
                        }
                    </div>
                    </div>
                    }
            
                </div>
            </div>
            @if (completedCount() === sortedQuestionnaireStatusList.length && sortedQuestionnaireStatusList.length > 0) {
                <!-- 若完成則不顯示按鈕 -->
            }@else{
                <div class="goToIdLogin-area">
                    <app-text size="m" weight="m" color="gray-900">
                        登入後即可線上填寫
                    </app-text>
                    <button mat-button class="btn-fill-primary" (click)="goToIdLogin()">
                        立即填寫問卷
                    </button>
                </div>
            }
        }@else{
            <app-text size="xl" weight="xl" color="gray-900">
            確認您的健檢前問卷狀態
            </app-text>
            <div class="idNo-area flex-column-flex-start">
            <!-- 身分證字號欄位 -->
            <form [formGroup]="step1Form">
                <div class="input-block">
                    <label class="input-title input-text-required" for="id-number">{{
                        'id-login.id-number' | translate
                    }}</label>
                    <div class="input-group input-btn-right">
                        <input
                            id="id-number"
                            matInput
                            type="text"
                            formControlName="idNo"
                            appMaskIdNumber
                            [maskEnabled]="!isIdNumberVisible"
                            [placeholder]="'id-login.id-number-placeholder' | translate"
                            [maxlength]="idNoMaxLength"
                            [ngClass]="{
                                'input-error': isFormSubmit && step1Form.get('idNo')?.invalid,
                            }"
                        />
                        <button
                            mat-icon-button
                            type="button"
                            class="input-password-btn"
                            (click)="toggleIdNumberVisibility()"
                        >
                            <img
                                [src]="isIdNumberVisible ? 'assets/img/i-eye.svg' : 'assets/img/i-eye-closed.svg'"
                                alt="toggle visibility"
                            />
                        </button>
                        @if (isFormSubmit && step1Form.get('idNo')?.invalid) {
                            <mat-error class="input-error-msg">{{ getIdNoErrorMessage() }}</mat-error>
                        }
                    </div>
                </div>
            </form>
        </div>
        <button mat-button type="submit" class="btn-fill-primary" (click)="onSubmit()">
            查詢問卷狀態
        </button>
    }
        

        
    </div>
</div>